import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getMenusV2 } from 'redux/actions/Menu/menuV2';
import UpdateProviderMenuButton from './UpdateProviderMenuButton';

const InventoryManagementHeader = ({ handleDrawerOpen, open }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  // Fetch menu data when navigating to inventory management (same as the
  // legacy inventory/menu headers) so the provider-menu button state and the
  // "Unpublished Inventory Changes" modal have the bulk/linked state they need.
  useEffect(() => {
    dispatch(getMenusV2(false));
  }, [location.pathname, dispatch]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        id="inventoryManagementHeaderMenu"
        aria-label="open drawer"
        onClick={handleDrawerOpen}
        edge="start"
        sx={{ mr: 2, ...(open && { display: 'none' }) }}
      >
        <MenuIcon />
      </IconButton>
      <Typography sx={{ color: '#3D4350', fontSize: '20px' }}>
        {t('Inventory Management')}
      </Typography>
      <UpdateProviderMenuButton buttonId="InventoryManagementSync" />
    </Box>
  );
};

export default InventoryManagementHeader;
